import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['petType', 'age', 'size']

  connect() {
    this.handleChange()
  }

  handleChange() {
    if (this.petTypeTarget.value === 'dog') {
      this.showDogFields()
    } else {
      this.hideDogFields()
    }
  }

  showDogFields() {
    this.toggleField(this.ageTarget, true, '* Age')
    this.toggleField(this.sizeTarget, true, '* Size')
  }

  hideDogFields() {
    this.toggleField(this.ageTarget, false, 'Age')
    this.toggleField(this.sizeTarget, false, 'Size')
  }

  toggleField(wrapper, visible, labelText) {
    const $wrapper = $(wrapper)
    const $select = $wrapper.find('select')
    const $label = $wrapper.find('label')

    if (visible) {
      $wrapper.show()
      $label.text(labelText)
      $select.prop('required', true)
    } else {
      $wrapper.hide()
      $label.text(labelText)
      $select.prop('required', false)
      $select.val('').trigger('change')
    }
  }
}
